const utils = {
  formatTableValue(value, format) {
    if (format) {
      if (format === '{0:d}' || format === '{0:dd MMM yyyy}') {
        const date = new Date(value);
        if (date.getFullYear() <= 1900) return '';
        return utils.getDateStr(date);
      } else if (format !== '') {
        const formatContent = format.replace(/({|})/g, () => '');
        const dotIndex = formatContent.indexOf('.');
        const numOfFractionDigits = formatContent.slice(dotIndex + 1).length;
        const numberFormat = new Intl.NumberFormat('en-GB', {
          maximumFractionDigits: numOfFractionDigits,
          minimumFractionDigits: numOfFractionDigits,
        });
        const factor = Math.pow(10, numOfFractionDigits);
        const rounded = Math.round(value * factor) / factor;

        const formatted = numberFormat.format(rounded === 0 ? 0 : value);
        //const formatted = numberFormat.format(value);
        return formatted;
      }
    }
    return value;
  },

  setDataToFormElements(data, formElements) {
    Object.keys(data).forEach((e) => {
      var key = e;
      var value = data[e];
      let item = formElements.find((o) => o.FieldName === key);
      if (item != null) {
        if (item.FieldType == 'datetime') {
          var myDate = new Date(value);
          if (myDate.getUTCFullYear() <= 1900) value = null;
        } else if (item.FieldType == 'CheckBox' && item.Type == 'string') {
          value = value === 'true' || value === true;
        }
        item.Value = value;
      }
    });
  },

  getDateStr(d) {
    const date = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    return (
      (date > 9 ? date.toString() : '0' + date) +
      '/' +
      (month > 9 ? month.toString() : '0' + month) +
      '/' +
      year.toString()
    );
  },

  dynamicSort(property, sortOrder = 1) {
    // property: string;  sortOrder: number = 1
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  },

  dynamicSortMultiple(propertiesArray, sortOrder = 1) {
    // property: string[];  sortOrder: number = 1
    /*
     * save the arguments object as it will be overwritten
     * note that arguments object is an array-like object
     * consisting of the names of the properties to sort by
     */
    var props = propertiesArray;
    return function (obj1, obj2) {
      var i = 0,
        result = 0,
        numberOfProperties = props.length;
      /* try getting a different result from 0 (equal)
       * as long as we have extra properties to compare
       */
      while (result === 0 && i < numberOfProperties) {
        result = this.dynamicSort(props[i], sortOrder)(obj1, obj2);
        i++;
      }
      return result;
    };
  },
  groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  },
};

export default utils;
